/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { PercPipe } from '../../../../../pipes/perc.pipe';
import { User } from '../../../../../models/User';
import { ChartData } from '../../../charts/models/ChartData';

@Component({
  selector: 'domain-ivt-overview',
  templateUrl: './domain-ivt-overview.component.html',
  styleUrls: ['./domain-ivt-overview.component.scss'],
  inputs: ['data']
})
export class DomainIvtOverview implements OnInit, OnChanges {
  @Input()
  isFollowing: boolean;
  @Input()
  data: any;

  percPipe = new PercPipe();
  sellers = [];
  trafficSources = [];
  deviceTypes = [];
  barChartData: Array<ChartData>;

  get isFreemium(): boolean {
    return this.userService.isFreemium();
  }

  constructor(private userService: User) {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.data) {
      if (this.data['sellersShareDistribution']) {
        if (this.data['sellersShareDistribution']['sellers']) {
          const sellers = this.data['sellersShareDistribution']['sellers'];
          this.sellers = sellers.slice();
          if (sellers.length > 3) {
            this.sellers = this.sellers.splice(0, 3);
          }

          for (const seller of this.sellers) {
            if (seller['totalTrafficRatio'] <= 0.01) {
              if (seller['totalTrafficRatio'] <= 0.005) {
                seller['styleWidth'] = '2px';
              } else {
                seller['styleWidth'] = '3px';
              }
            } else {
              seller['styleWidth'] = this.percPipe.transform(
                seller['totalTrafficRatio'],
                '1.2-2'
              );
            }
          }

          this.sellers.sort((seller1, seller2) => {
            if (seller1['paymentType'] === seller2['paymentType']) {
              return 0;
            } else if (seller1['paymentType'] === 'N/A') {
              return 1;
            } else if (seller2['paymentType'] === 'N/A') {
              return -1;
            } else if (seller1['paymentType'] > seller2['paymentType']) {
              return 1;
            } else if (seller1['paymentType'] < seller2['paymentType']) {
              return -1;
            }
          });
        }
      }

      try {
        if (this.data['trafficDistribution']) {
          if (this.data['trafficDistribution']['trafficSources']) {
            const trafficSources =
              this.data['trafficDistribution']['trafficSources'];
            this.trafficSources = trafficSources.slice();
            if (trafficSources.length > 3) {
              this.trafficSources = this.trafficSources.splice(0, 3);
            }
            for (const trafficSource of this.trafficSources) {
              if (trafficSource['totalTrafficRatio'] <= 0.01) {
                if (trafficSource['totalTrafficRatio'] <= 0.005) {
                  trafficSource['styleWidth'] = '2px';
                } else {
                  trafficSource['styleWidth'] = '3px';
                }
              } else {
                trafficSource['styleWidth'] = this.percPipe.transform(
                  trafficSource['totalTrafficRatio'],
                  '1.2-2'
                );
              }
            }
          }
        }
      } catch (e) {
        console.error(e); // TODO: Investigate what caused data mutation
      }

      if (this.data['deviceDistribution']) {
        if (this.data['deviceDistribution']['deviceTypes']) {
          const deviceTypes = this.data['deviceDistribution']['deviceTypes'];
          this.deviceTypes = deviceTypes.slice();
          if (deviceTypes.length > 3) {
            this.deviceTypes = this.deviceTypes.splice(0, 3);
          }
          for (const deviceType of this.deviceTypes) {
            if (deviceType['totalTrafficRatio'] <= 0.01) {
              if (deviceType['totalTrafficRatio'] <= 0.005) {
                deviceType['styleWidth'] = '2px';
              } else {
                deviceType['styleWidth'] = '3px';
              }
            } else {
              deviceType['styleWidth'] = this.percPipe.transform(
                deviceType['totalTrafficRatio'],
                '1.2-2'
              );
            }
          }
        }
      }

      if (this?.data?.ivtDistribution?.byMonth) {
        this.barChartData = this?.data?.ivtDistribution?.byMonth;
        this.barChartData.reverse();
      }
    }
  }
}
